var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whiteBack"},[_c('h4',{staticClass:"mb-2"},[_vm._v("Background Check Status")]),_c('div',{staticClass:"mb-3"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.userBackgroundChecks,"styleClass":"vgt-table condensed","compactMode":"","pagination-options":{
          enabled: true,
          mode: 'records',
          perPage: 10,
        }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }